import React, { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import online from "../../images/landingPage/online.svg";
import HomeNavBar from "../components/HomeNavBar";
import { useSelector, useDispatch } from "react-redux";
import Footer from "../components/Footer";
import { Link, useParams } from "react-router-dom";
import { getCertificationDetails } from "../../actions/home/home_action";

const CertificationDetails = () => {
  const state = useSelector((state) => state.homeReducer);
  const dispatch = useDispatch("");
  const [search, setSearch] = useState();
  const { id } = useParams();
  //let decodedId = window.atob(id);
  useEffect(() => {
    dispatch(getCertificationDetails({ id: window.atob(id) }));
  }, []);

  return (
    <LoadingOverlay active={state.loading} spinner text="Loading...">
      <div className="main-landing-page traning-landing-page landing-container">
        {/* navbar */}
        <HomeNavBar />
        <br />
        <div className="container">
          <div className="row cource-section">
            <div className="col-lg-12 mb-3">
              <div className="box">
                <div class="paths-content-highlight paths-aside-box show-for-large-up">
                  <div class="paths-aside-scrollable">
                    <div className="cert-details-div">
                      <Link
                        to={"/certifications"}
                        className="d-inline-block mt-2"
                        title={"Certifications"}
                      >
                        <i className="ti-arrow-left font-sm text-white"></i>
                      </Link>
                      <h1 className="text-white text-center cer-details-heading">
                        Certification Details
                      </h1>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 mb-2">
                        <h3 className="color-white">Certification Name:</h3>
                      </div>
                      <div className="col-lg-9 mb-2">
                        <h4 className="color-white">
                          {state.certification && state.certification.name}
                        </h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 mb-2">
                        <h3 className="color-white">Certification: </h3>
                      </div>
                      <div className="col-lg-9 mb-2">
                        <a
                          href={
                            state.certification &&
                            state.certification.product_link
                          }
                          target="-"
                        >
                          <h4 className="color-white">
                            {state.certification &&
                              state.certification.product_link}
                          </h4>
                        </a>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 mb-2">
                        <h3 className="color-white">Exam Link: </h3>
                      </div>
                      <div className="col-lg-9 mb-2">
                        <a
                          href={
                            state.certification && state.certification.exam_link
                          }
                          target="-"
                        >
                          <h4 className="color-white">
                            {state.certification &&
                              state.certification.exam_link}
                          </h4>
                        </a>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 mb-2">
                        <h3 className="color-white">Role Credentials : </h3>
                      </div>
                      <div className="col-lg-9 mb-2">
                        <h4 className="color-white">
                          {state.certification &&
                            state.certification.certification_role +
                              "-" +
                              state.certification.level}
                        </h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 mb-2">
                        <h3 className="color-white">Required Experience:</h3>
                      </div>
                      <div className="col-lg-9 mb-2">
                        <h4 className="color-white">
                          {state.certification &&
                            state.certification.recommended_experience}
                        </h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 mb-2">
                        <h3 className="color-white">Pre-requisite:</h3>
                      </div>
                      <div className="col-lg-9 mb-2">
                        <h4 className="color-white">
                          {state.certification &&
                          state.certification.certification_prerequisites === ""
                            ? "NA"
                            : state.certification.certification_prerequisites}
                        </h4>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 mb-2">
                        <h3 className="color-white">
                          Certfication Description:
                        </h3>
                      </div>
                      <div className="col-lg-9 mb-2">
                        <h4 className="color-white">
                          {" "}
                          {state.certification &&
                            state.certification.certification_description}
                           </h4>
                      </div>
                    </div>                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer */}
        <Footer />
      </div>
    </LoadingOverlay>
  );
};

export default CertificationDetails;
